<template>
  <div>
    <v-row>
      <v-col sm="12">
        <gmap-autocomplete
          :placeholder="$t('locations.enter_address')"
          @place_changed="setPlace"
          :select-first-on-enter="true"
          class="address-autocomplete"
          :disabled="fillByHand"
          :value="addressString"
        >
        </gmap-autocomplete>
      </v-col>
      <v-col sm="12" v-if="missingAddressFields && !fillByHand" class="py-0">
        <v-alert
          outlined
          dense
          type="warning"
        >
          {{$t('locations.address_not_complete')}}
        </v-alert>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-checkbox
        color="kazan"
          v-model="fillByHand"
          :label="$t('locations.fill_by_hand')"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" v-if="fillByHand" class="py-0">
        <v-alert
          dense
          outlined
          type="info"
        >
          {{$t('locations.be_careful')}}
        </v-alert>
      </v-col>
      <v-col sm="4">
        <v-text-field
          :label="$t('locations.street') + ' *'"
          v-model="address.address.street"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="2">
        <v-text-field
          :label="$t('locations.street_number') + ' *'"
          v-model="address.address.streetNo"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="6">
        <v-select
          item-text="text"
          :items="countries"
          :label="$t('locations.country') + ' *'"
          v-model="address.address.countryCode"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-select>
      </v-col>
      <v-col sm="4">
        <v-text-field
          :label="$t('locations.city') + ' *'"
          v-model="address.address.city"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="2">
        <v-text-field
          :label="$t('locations.postal_code') + ' *'"
          v-model="address.address.postalCode"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="2">
        <v-text-field
          :label="$t('locations.lat') + ' *'"
          v-model="address.coordinates.lat"
          type="number"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="2">
        <v-text-field
          :label="$t('locations.lng') + ' *'"
          v-model="address.coordinates.lng"
          type="number"
          :disabled="!fillByHand"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'LocationFormAddress',
  props: ['value', 'isUpdate'],
  data () {
    return {
      countries: [
        { text: this.$i18n.t('countries.Austria'), value: 'AT' },
        { text: this.$i18n.t('countries.Czech_Republic'), value: 'CZ' },
        { text: this.$i18n.t('countries.Slovakia'), value: 'SK' },
        { text: this.$i18n.t('countries.Germany'), value: 'DE' },
        { text: this.$i18n.t('countries.Poland'), value: 'PL' },
        { text: this.$i18n.t('countries.Italy'), value: 'IT' }
      ],
      address: JSON.parse(JSON.stringify(this.value)),
      missingAddressFields: false,
      fillByHand: false
    }
  },
  created () {
    if (this.isUpdate) {
      this.fillByHand = true
    }
  },
  computed: {
    addressString () {
      return `${this.address.address.street ? this.address.address.street + ' ' : ''}${this.address.address.streetNo ? this.address.address.streetNo + ' ' : ''}${this.address.address.city ? this.address.address.city : ''}`
    }
  },
  methods: {
    setPlace (place) {
      // console.log(place)
      let street = ''
      let streetNumber = ''
      let locality = ''
      let sublocality = ''
      let city = ''
      let postalCode = ''
      // let country = ''
      let countryCode = ''
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      place.address_components.forEach(el => {
        if (el.types.includes('street_number')) {
          streetNumber = el.long_name
        } else if (el.types.includes('route')) {
          street = el.long_name
        } else if (el.types.includes('postal_code')) {
          postalCode = el.long_name
        } else if (el.types.includes('country')) {
          // country = el.long_name
          countryCode = el.short_name
        } else if (el.types.includes('locality')) {
          locality = el.long_name
        } else if (el.types.includes('sublocality')) {
          sublocality = el.long_name
        }
      })
      city = (locality === '' ? sublocality : locality)
      this.address.address.street = street
      this.address.address.streetNo = streetNumber
      this.address.address.city = city
      this.address.address.postalCode = postalCode
      this.address.address.country = countryCode
      this.address.address.countryCode = countryCode
      this.$set(this.address.coordinates, 'lat', lat)
      this.$set(this.address.coordinates, 'lng', lng)
      let addr = this.address.address
      let cord = this.address.coordinates
      if (!addr.street || !addr.streetNo || !addr.city || !addr.postalCode || !addr.country || !cord.lat || !cord.lng) {
        this.missingAddressFields = true
      } else {
        this.missingAddressFields = false
      }
    }
  },
  watch: {
    address: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .address-autocomplete {
    width: 100%;
    padding: 8px;
    border: 1px solid grey;
    border-radius: 5px;

    &:focus {
      border: 2px solid grey;
      outline: none;
      padding: 7px;
    }

    &:disabled {
      border-color: lightgrey;
      color: lightgray;

      &::placeholder {
        color: lightgray;
      }
    }
  }
  .v-alert.v-alert--outline.info--text {
    padding: 10px 20px;
  }
</style>
